import codes from 'locale-codes';

const Locales = codes.all
  .filter((code) => code.tag.length === 2)
  .map((code) => ({ id: code.tag, name: code.name }));

export default Locales;
